import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ClientRequestDocumentUploadModel, ClientRequestModel } from '@aiwyn/api';
import { Loadable, Logger } from '@aiwyn/shared';
import { BaseCommonClientRequest, CommonClientRequestDocumentUpload } from '@aiwyn/common/client-requests';

/**
 * TODO: Create a factory service that has creation functions for each entity (group, request, assignee, etc.). Then pass that factory to
 *  the base classes so that they can create the correct class (common vs feature). If that works, we'll need to separate the base classes
 *  from the child classes.
 */

export class BaseClientRequest<
  ClientRequest extends ClientRequestModel = ClientRequestModel,
  ClientRequestTypeClass extends RequestModelToClassMap<ClientRequest> = RequestModelToClassMap<ClientRequest>,
> extends BaseCommonClientRequest<ClientRequest, ClientRequestTypeClass> {
  protected _create$(
    model$: Observable<Loadable<ClientRequest>>,
    store: Store,
    logger: Logger,
  ): Observable<ClientRequestTypeClass> {
    return model$.pipe(
      map(type => {
        return new ClientRequestDocumentUpload(
          model$ as Observable<Loadable<ClientRequestDocumentUploadModel>>,
          store,
          logger,
        ) as ClientRequestTypeClass;
      }),
    );
  }
}

export class ClientRequestDocumentUpload extends CommonClientRequestDocumentUpload {
  statusDetails$ = this.model$.pipe(
    map(({ data }) => data.progress),
  );
}

export type RequestModelToClassMap<ClientRequest extends ClientRequestModel> =
  ClientRequest extends ClientRequestDocumentUploadModel
    ? ClientRequestDocumentUpload
    : never;

